module.exports = __webpack_public_path__ + "static/thc_icon-9610397a28005067ff2fa84a876dfa31.svg";